@use '@lib/assets/styles/main.scss' as *;

.rowWrap {
  position: relative;

  &.rowWrapWithAction {
    padding-right: 48px;
  }
}

.actionBtn {
  position: absolute;
  top: 8px;
  right: 0;
}
